// removed by extract-text-webpack-plugin
module.exports = {"popupContent":"TvCodeExpiryPopup__popupContent","content":"TvCodeExpiryPopup__content","title":"TvCodeExpiryPopup__title","message":"TvCodeExpiryPopup__message","errorMessage":"TvCodeExpiryPopup__errorMessage","textInput":"TvCodeExpiryPopup__textInput","okButton":"TvCodeExpiryPopup__okButton","growDotQello":"TvCodeExpiryPopup__growDotQello","growDotBlue":"TvCodeExpiryPopup__growDotBlue","growDotGolden":"TvCodeExpiryPopup__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Popup/TvCodeExpiryPopup/TvCodeExpiryPopup.scss
// module id = 1876
// module chunks = 0